module.exports = __webpack_public_path__ + "static/media/6.0c59b6ae.png";